import { INavData } from '@coreui/angular';
export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {

    name: 'Configuración',
    icon: 'icon-settings',

    children: [
    /*  {
        name: 'Contribuyente',
        url: '/emisor'
      },*/
      {
        name: 'Unidades',
        url: '/unidades'
      },
      {
        name: 'Forma de Pago',
        url: '/formaPago'
      },
      {
        name: 'Vendedor',
        url: '/vendedor'
      }
      ,
      {
        name: 'Empleado',
        url: '/empleado'
      }
    ]
  },
  {
    name: 'SRI',
    icon: 'cil-dollar',
    children: [

      {
        name: 'Comprobantes Electronicos',
        url: '/electronicos'
      },

      {
        name: 'Cargar Facturas',
        url: '/facturaxls'
      },

      {
        name: 'ATS',
        url: '/electronicos'
      }]
  },

  {
    name: 'Ventas',
    icon: 'icon-basket',
    children: [

     
      {
        name: 'Factura Comercial',
        url: '/facturar'
      },{
        name: 'Factura Tactil',
        url: '/facturarTouch'
      }
      ,
      {
        name: 'Apertura Caja y Cierre',
        url: '/caja'
      },
     
      {
        name: 'Reporte Caja',
        url: '/reporteCaja'
      },
      {
        name: 'Anular Venta',
        url: '/anularv'
      },
       {
        name: 'Reimprimir Venta',
        url: '/reimprimir'
      },
      {
        name: 'Pedido',
        url: '/pedido'
      },
      {
        name: 'Grupos Productos',
        url: '/grupos'
      },
      {
        name: 'Productos',
        url: '/productos'
      }

      ,
      {
        name: 'Clientes',
        url: '/clientes'
      }

    ]

  },


  {
    name: 'Inventario',
    icon: 'icon-book-open',
    children: [
      {
        name: 'Compras',
        url: '/compras'

      },
      {
        name: 'Egresos',
        url: '/egresos'

      }

      ,
      {
        name: 'Proveedores',
        url: '/proveedor'
      }
      ,
      {
        name: 'Inventario',
        url: '/inventario'
      },
  
      {
        name: 'Fisico',
        url: '/fisico'
      },
      {
        name: 'Kardex Por Produc.',
        url: '/kardex'
      }
      ,
      {
        name: 'Canales',
        url: '/canales'
      }
    ]

  },



  {
    name: 'Cuentas Por Cobrar',
    icon: 'icon-check',
    children: [
      {
        name: 'Registro CxC',
        url: '/cxc'

      }


    ]

  },
 

  {
    name: 'Cuentas Por Pagar',
    icon: 'icon-check',
    children: [
      {
        name: 'Proveedor',
        url: '/cxc'

      },
      {
        name: 'Empleados',
        url: '/productos'

      }


    ]

  },

  {
    name: 'Contabilidad',
    icon: 'icon-check',
    children: [
      {
        name: 'Retencion Ventas',
        url: '/RetencionxVenta'

      },
      {
        name: 'Retencion Compras',
        url: '/retencionCompras'

      },
    
    ]
  },

  {
    name: 'Reportes',
    icon: 'icon-pie-chart',

    children: [
      {
        name: 'Ventas por Cliente',
        url: '/ventaCli'
      },
      {
        name: 'Ventas por Mes',
        url: '/ventaMes'
      }
      ,
      {
        name: 'Ventas por Producto',
        url: '/ventaProd'
      }
      ,
      {
        name: 'Top Producto Vendidos',
        url: '/utilidad'
      }
      ,
      {
        name: 'Utilidad',
        url: '/utilidad'
      }
      ,
      {
        name: 'Cuentas por Cobrar',
        url: '/ReporteCxC'
      }
      ,
      {
        name: 'Cientes/Proveedores',
        url: '/ReporteClienteProveedor'
      },
      
      {
        name: 'Productos Caducados',
        url: '/caducidad'
      }


    ]

  },


  /* {
   title: true,
   name: 'Theme'
 },
 {
   name: 'Colors',
   url: '/theme/colors',
   icon: 'icon-drop'
 },
 {
   name: 'Typography1111',
   url: '/theme/typography',
   icon: 'icon-pencil'
 },
 {
   title: true,
   name: 'Components'
 },
 {
   name: 'Base',
   url: '/base',
   icon: 'icon-puzzle',
   children: [
     {
       name: 'Cards',
       url: '/base/cards',
       icon: 'icon-puzzle'
     },
     {
       name: 'Carousels',
       url: '/base/carousels',
       icon: 'icon-puzzle'
     },
     {
       name: 'Collapses',
       url: '/base/collapses',
       icon: 'icon-puzzle'
     },
     {
       name: 'Forms',
       url: '/base/forms',
       icon: 'icon-puzzle'
     },
     {
       name: 'Navbars',
       url: '/base/navbars',
       icon: 'icon-puzzle'

     },
     {
       name: 'Pagination',
       url: '/base/paginations',
       icon: 'icon-puzzle'
     },
     {
       name: 'Popovers',
       url: '/base/popovers',
       icon: 'icon-puzzle'
     },
     {
       name: 'Progress',
       url: '/base/progress',
       icon: 'icon-puzzle'
     },
     {
       name: 'Switches',
       url: '/base/switches',
       icon: 'icon-puzzle'
     },
     {
       name: 'Tables',
       url: '/base/tables',
       icon: 'icon-puzzle'
     },
     {
       name: 'Tabs',
       url: '/base/tabs',
       icon: 'icon-puzzle'
     },
     {
       name: 'Tooltips',
       url: '/base/tooltips',
       icon: 'icon-puzzle'
     }
   ]
 },
 {
   name: 'Buttons',
   url: '/buttons',
   icon: 'icon-cursor',
   children: [
     {
       name: 'Buttons',
       url: '/buttons/buttons',
       icon: 'icon-cursor'
     },
     {
       name: 'Dropdowns',
       url: '/buttons/dropdowns',
       icon: 'icon-cursor'
     },
     {
       name: 'Brand Buttons',
       url: '/buttons/brand-buttons',
       icon: 'icon-cursor'
     }
   ]
 },
 {
   name: 'Charts',
   url: '/charts',
   icon: 'icon-pie-chart'
 },
 {                                                                                                                          
   name: 'Icons',
   url: '/icons',
   icon: 'icon-star',
   children: [
     {
       name: 'CoreUI Icons',
       url: '/icons/coreui-icons',
       icon: 'icon-star',
       badge: {
         variant: 'success',
         text: 'NEW'
       }
     },
     {
       name: 'Flags',
       url: '/icons/flags',
       icon: 'icon-star'
     },
     {
       name: 'Font Awesome',
       url: '/icons/font-awesome',
       icon: 'icon-star',
       badge: {
         variant: 'secondary',
         text: '4.7'
       }
     },
     {
       name: 'Simple Line Icons',
       url: '/icons/simple-line-icons',
       icon: 'icon-star'
     }
   ]
 },
 {
   name: 'Notifications',
   url: '/notifications',
   icon: 'icon-bell',
   children: [
     {
       name: 'Alerts',
       url: '/notifications/alerts',
       icon: 'icon-bell'
     },
     {
       name: 'Badges',
       url: '/notifications/badges',
       icon: 'icon-bell'
     },
     {
       name: 'Modals',
       url: '/notifications/modals',
       icon: 'icon-bell'
     }
   ]
 },
 {
   name: 'Widgets',
   url: '/widgets',
   icon: 'icon-calculator',
   badge: {
     variant: 'info',
     text: 'NEW'
   }
 },
 {
   divider: true
 },
 {
   title: true,
   name: 'Extras',
 },
 {
   name: 'Pages',
   url: '/pages',
   icon: 'icon-star',
   children: [
     {
       name: 'Login',
       url: '/login',
       icon: 'icon-star'
     },
     {
       name: 'Register',
       url: '/register',
       icon: 'icon-star'
     },
     {
       name: 'Error 404',
       url: '/404',
       icon: 'icon-star'
     },
     {
       name: 'Error 500',
       url: '/500',
       icon: 'icon-star'
     }
   ]
 },
 {
   name: 'Disabled',
   url: '/dashboard',
   icon: 'icon-ban',
   badge: {
     variant: 'secondary',
     text: 'NEW'
   },
   attributes: { disabled: true },
 }
,
 {
   name: 'Download CoreUI',
   url: 'http://coreui.io/angular/',
   icon: 'icon-cloud-download',
   class: 'mt-auto',
   variant: 'success',
   attributes: { target: '_blank', rel: 'noopener' }
 }
/* ,{
   name: 'Try CoreUI PRO',
   url: 'http://coreui.io/pro/angular/',
   icon: 'icon-layers',
   variant: 'danger',
   attributes: { target: '_blank', rel: 'noopener' }
 }*/
];
